import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function InspectionsList() {
  const [inspections, setInspections] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
  const token = localStorage.getItem('token');
  if (!token) {
    navigate('/admin/login'); // Changed from /admin/login
    return;
  }

    const checkToken = () => {
      axios.get(`${process.env.REACT_APP_API_URL}/api/admin/dashboard`, {
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => {
        localStorage.removeItem('token');
        navigate('/admin/login');
      });
    };

    checkToken();

    const inactivityTimeout = 5 * 60 * 1000; // 5 minutes in ms
    let inactivityTimer;

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        localStorage.removeItem('token');
        navigate('/admin/login');
        alert('Logged out due to inactivity.');
      }, inactivityTimeout);
    };

    resetTimer();

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);

    axios.get(`${process.env.REACT_APP_API_URL}/api/inspections`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => setInspections(res.data))
      .catch(err => console.error('Error fetching inspections:', err));

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [navigate]);

  if (!localStorage.getItem('token')) return null;

  return (
    <div className="p-8 bg-white text-black font-fairplay">
      <h2 className="text-2xl font-bold mb-4">Inspection Requests</h2>
      <table className="w-full border-collapse rounded-lg shadow-md">
        <thead>
          <tr className="bg-gray-100 text-black">
            <th className="border p-3 text-left">Name</th>
            <th className="border p-3 text-left">Phone</th>
            <th className="border p-3 text-left">Email</th>
            <th className="border p-3 text-left">Car Make</th>
            <th className="border p-3 text-left">Car Model</th>
            <th className="border p-3 text-left">Inspection Date</th>
            <th className="border p-3 text-left">Other Info</th>
          </tr>
        </thead>
        <tbody>
          {inspections.map(inspection => (
            <tr key={inspection.id} className="hover:bg-gray-100">
              <td className="border p-2">{inspection.name}</td>
              <td className="border p-2">{inspection.phone}</td>
              <td className="border p-2">{inspection.email}</td>
              <td className="border p-2">{inspection.car_make}</td>
              <td className="border p-2">{inspection.car_model}</td>
              <td className="border p-2">{inspection.inspection_date}</td>
              <td className="border p-2">{inspection.other_info || 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}